<template>
  <div class="content content-depotfinder content-depotfinder--nobg">
    <div class="content__inner">
      <div class="wrapper">
        <BackButton @click="handleBack('/depotfinder')" />

        <DepositmodelResults
          :recommendedDeposit="recommendedDeposit"
          @triggerCompare="getAlternativeDepositModel"
        />

        <DepotfinderResults
          v-if="!showCompareView && !showInformationView"
          :depositModel="depositModel"
          :activeDepositModel="activeDepositModel"
          :recommendedDeposit="recommendedDeposit"
        />

        <CompareView
          v-if="showCompareView"
          :activeDeposit="depositModel"
          :alternativeDeposit="alternativeDepositModel"
          :alternativeDepositName="alternativeDepositModelName"
          :activeDepositModel="activeDepositModel"
        />

        <ChangeTarrif
          v-if="showChangeTarrifView"
          :activeDepositModel="activeDepositModel"
        />

        <RequestInformation
          v-show="showInformationView"
          :activeDepositModel="activeDepositModel"
          :recommendedDepositModel="recommendedDeposit"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DepositmodelResults from "./../../components/DepositModelResults.vue";
import DepotfinderResults from "./../../components/DepotfinderResults.vue";
import BackButton from "./../../components/BackButton.vue";
import CompareView from "./../../components/CompareView.vue";
import ChangeTarrif from "./../../components/ChangeTarrif.vue";
import RequestInformation from "./../../components/RequestInformation.vue";
import { backButtonMixin } from "./../../mixins/handleBackButton";
import { viewOrder } from "./../../mixins/settings";

export default {
  mixins: [backButtonMixin, viewOrder],
  components: {
    DepositmodelResults,
    DepotfinderResults,
    CompareView,
    ChangeTarrif,
    RequestInformation,
    BackButton
  },
  data() {
    return {
      recommendedDeposit: this.$store.getters.getRecommendedDeposit,
      depositModels: this.$store.getters.getDepositModels,
      alternativeDepositModelName: ""
    };
  },
  computed: {
    depositModel() {
      let depositModel = {};
      if (this.activeDepositModel != "") {
        depositModel = this.$t(`depositmodels.${this.activeDepositModel}`);
      }
      return depositModel;
    },
    activeDepositModel() {
      return this.$store.getters.getActiveDeposit;
    },
    alternativeDepositModel() {
      return this.$store.getters.getAlternativeDeposit;
    },
    showCompareView() {
      return this.$store.getters.getCompareViewState;
    },
    showChangeTarrifView() {
      return this.activeDepositModel.indexOf("DepotExklusiv") != -1;
    },
    showInformationView() {
      return this.$store.getters.getInformationViewState;
    }
  },
  methods: {
    getAlternativeDepositModel(model) {
      let alternativeDeposit = {};
      if (model != undefined) {
        alternativeDeposit = this.$t(`depositmodels.${model}`);
      }
      this.$store.dispatch("updateAlternativeDeposit", alternativeDeposit);
      this.alternativeDepositModelName = model;
      return alternativeDeposit;
    },
    closeCompareView() {
      this.$store.dispatch("updateView", {
        view: "compareView",
        payload: false
      });
    }
  },
  mounted() {
    if (this.activeDepositModel == "") {
      this.$store.dispatch("updateActiveDeposit", this.recommendedDeposit);
    }
  },
  updated() {
    // scroll to top if view changed
    window.scrollTo(0, 0);
  },
  beforeDestroy() {
    // Disable compare view when results view is left
    this.$store.dispatch("updateView", {
      view: "compareView",
      payload: false
    });
    // Reset activeDepositTab & activeDeposit
    this.$store.dispatch("updateActiveDepositTab", this.recommendedDeposit);
    this.$store.dispatch("updateActiveDeposit", "");
  }
};
</script>
